import React from "react";
import { Link } from "react-router-dom";
import imgLogo from "../../assets/logo.png";

import "./styles.css";

const Render = (props, context) => {
  return (
    <section className="preSite coverAll passwordCreate">
      <div className="container">
        <h1 className="mbl">
          <img
            src={imgLogo}
            alt="Superheroes."
            className="logo displayBlock mha"
          />
        </h1>

        <p className="formMsg pvl mha white alignCenter">
          La contraseña debe tener 8 caracteres como mínimo.
        </p>

        {props.error && (
          <p className={`formMsg pvl mha white alignCenter`}>{props.error}</p>
        )}

        <form className="mha" onSubmit={props.onSubmit}>
          <label htmlFor="passwordCreate">
            <span className="labelName">Ingresar una contraseña</span>
            <input
              type="password"
              name="passwordCreate"
              id="passwordCreate"
              className="passwordCreate"
            />
          </label>

          <label htmlFor="passwordConfirm">
            <span className="labelName">Repetir contraseña</span>
            <input
              type="password"
              name="passwordConfirm"
              id="passwordConfirm"
              className="passwordConfirm"
            />
          </label>

          <input type="submit" value="Ingresar" className="btn mha" />
        </form>

        <p className="formNote displayBlock mtl white alignCenter">
          Ya tengo usuario.{" "}
          <Link to="/" className="white">
            Ingresar
          </Link>
        </p>
      </div>
    </section>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/PasswordCreate/Render.js